import { render } from "./YouTubeVideo.vue?vue&type=template&id=72f6ae24"
import script from "./YouTubeVideo.vue?vue&type=script&lang=js"
export * from "./YouTubeVideo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ognjenq/Sites/petarboats/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__